import PROUNI_VIEWS_NAMES from '@/router/prouniViewsNames';
import steps from './steps';

export default {
  [steps.personalData]: PROUNI_VIEWS_NAMES.PROUNI_PERSONAL_DATA,
  [steps.personalDocuments]: PROUNI_VIEWS_NAMES.PROUNI_PERSONAL_DOCUMENTS,
  [steps.residence]: PROUNI_VIEWS_NAMES.PROUNI_RESIDENCE,
  [steps.familyIncome]: PROUNI_VIEWS_NAMES.PROUNI_FAMILY_INCOME,
  [steps.education]: PROUNI_VIEWS_NAMES.PROUNI_EDUCATION,
  [steps.acceptance]: PROUNI_VIEWS_NAMES.PROUNI_ACCEPTANCE,
} as Record<string, string>;
